import type { ICellRendererParams } from 'ag-grid-enterprise'
import type { ReactElement } from 'react'
import type { IUserPublic } from '~/types/user'

import Team from '~/components/Team'
import { useUserDetailsQueries } from '~/queries/users'

type BasicUserInfo = {
  job: string
  name: string
  picture?: string
}

const TeamCellRenderer = ({ value }: ICellRendererParams): ReactElement => {
  const formatUser = (user?: IUserPublic) =>
    user ? { job: user.profile?.job_title || '', name: user.name, picture: user.picture } : undefined

  const userQueries = useUserDetailsQueries(value, formatUser)

  const userArray = userQueries.some((e) => e.isLoading)
    ? []
    : userQueries.map(({ data }) => data as BasicUserInfo).filter((value) => value)

  return value ? <Team size="small" users={userArray} /> : <div />
}

export default TeamCellRenderer
